import { PropsWithChildren } from 'react';

import { BarSvgProps, BarDatum } from '@nivo/bar';
import { PropertyAccessor } from '@nivo/core';
import { FormatNumberOptions, IntlShape } from 'react-intl';

export const chartTheme: BarSvgProps<BarDatum>['theme'] = {
  background: '#1f1f1f',
  textColor: '#ffffff',
  labels: {
    text: {
      font: "700 16px/1.25 'PT Mono'",
    },
  },
  crosshair: {
    line: {
      stroke: '#28303e',
      strokeWidth: 1,
    },
  },
  axis: {
    ticks: {
      text: {
        font: "400 10px/1.67 'Heebo'",
        fill: '#9e9e9e',
      },
    },
  },
};

export function StyledTooltip({ children }: PropsWithChildren<unknown>) {
  return (
    <div className="max-w-300px rounded bg-slate-500 px-4 py-3 font-heebo text-sm font-normal leading-1.43 text-slate-50">
      {children}
    </div>
  );
}

export type CommonChartProps<T> = {
  data: T[];
  mode?: 'card' | 'modal';
  height: string;
  width: string;
  keyField: PropertyAccessor<T, string>;
  valueField?: PropertyAccessor<T, number>;
  formatKey?: (value: string) => string;
  valueFormatOptions?: FormatNumberOptions & {
    prepareNumber?: (value: number) => number;
  };
};

export function formatValue<T>(
  intl: IntlShape,
  value: number | null,
  valueFormatOptions?: CommonChartProps<T>['valueFormatOptions'],
) {
  if (value === null) {
    return '-';
  }
  if (valueFormatOptions?.prepareNumber) {
    const preparedValue = valueFormatOptions.prepareNumber(value);
    return intl.formatNumber(preparedValue, valueFormatOptions);
  }

  return value.toLocaleString(intl.locale, valueFormatOptions);
}

export const chartColors = ['#e028dd', '#f093ee', '#3142c4', '#6475f7', '#b1bafb'];
